import { Switch, Route } from "react-router-dom";
import AuthRoute from "ui/components/AuthRoute";
import AdminPages from "./Admin";
import ErrorsPages from "./Errors";
import AuthPages from "./Auth";
import Onboarding from './Onboarding';
import DownloadBoletos from "./Admin/Financeiro/DownloadBoletos";

function Pages() {
  return (
    <Switch>
      <Route path="/auth" component={AuthPages} />
      <Route path="/errors" component={ErrorsPages} />
      <AuthRoute path="/onboarding" component={Onboarding} />
      <AuthRoute
        path="/financeiro/download-boletos/:hash"
        component={DownloadBoletos}
      />
      <AuthRoute path="/" component={AdminPages} />
    </Switch>
  );
}

export default Pages;
